import LegalPage from "../../components/legal/LegalPage";
import document from "../../content/legal/community-guidelines.json";

export default function Page() {
  return <LegalPage title="Community Guidelines" document={document} />;
}
